import React from "react";
import { Check, X } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { Reveal } from "../motion/Reveal";
import { SectionKicker } from "./Manifesto";

export const Compare = () => {
  const { t } = useLang();
  return (
    <section className="relative z-10 py-24 md:py-32 border-t border-white/10" data-testid="compare-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <SectionKicker>{t.compare.kicker}</SectionKicker>
          <h2 className="font-display font-extrabold tracking-tighter text-4xl md:text-6xl leading-[0.95]">
            {t.compare.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-5">
          {/* Green side */}
          <Reveal>
            <div className="relative rounded-2xl border border-emerald2/40 bg-gradient-to-b from-emerald2/15 to-transparent p-8 md:p-10 h-full">
              <h3 className="font-display text-2xl md:text-3xl font-bold text-lime2">{t.compare.green}</h3>
              <ul className="mt-8 space-y-5">
                {t.compare.rows.map((r) => (
                  <li key={r.l} className="flex items-start justify-between gap-4 border-b border-white/10 pb-4">
                    <span className="text-white/50 text-sm">{r.l}</span>
                    <span className="flex items-center gap-2 text-right text-sm font-medium text-offwhite">
                      <Check size={16} className="text-emerald2 shrink-0" /> {r.g}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {/* Brown side */}
          <Reveal delay={0.12}>
            <div className="relative rounded-2xl border border-white/10 bg-[#141414] p-8 md:p-10 h-full grayscale-[40%]">
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white/50">{t.compare.brown}</h3>
              <ul className="mt-8 space-y-5">
                {t.compare.rows.map((r) => (
                  <li key={r.l} className="flex items-start justify-between gap-4 border-b border-white/10 pb-4">
                    <span className="text-white/40 text-sm">{r.l}</span>
                    <span className="flex items-center gap-2 text-right text-sm text-white/60">
                      <X size={16} className="text-red-500/70 shrink-0" /> {r.b}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
